// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tdtE","type":"styles_type__1Ql_j","choices":"styles_choices__2HLER"};